__turbopack_context__.v({
  "attributes": "CollectionFeed-module__DQ6EBW__attributes",
  "body": "CollectionFeed-module__DQ6EBW__body",
  "bold": "CollectionFeed-module__DQ6EBW__bold",
  "cardsGrid": "CollectionFeed-module__DQ6EBW__cardsGrid",
  "column": "CollectionFeed-module__DQ6EBW__column",
  "container": "CollectionFeed-module__DQ6EBW__container",
  "emptyState": "CollectionFeed-module__DQ6EBW__emptyState",
  "emptyText": "CollectionFeed-module__DQ6EBW__emptyText",
  "fungibleColumn": "CollectionFeed-module__DQ6EBW__fungibleColumn",
  "fungibleSoldHeader": "CollectionFeed-module__DQ6EBW__fungibleSoldHeader",
  "grid": "CollectionFeed-module__DQ6EBW__grid",
  "gridAttrs": "CollectionFeed-module__DQ6EBW__gridAttrs",
  "header": "CollectionFeed-module__DQ6EBW__header",
  "infiniteScroll": "CollectionFeed-module__DQ6EBW__infiniteScroll",
  "loading": "CollectionFeed-module__DQ6EBW__loading",
  "root": "CollectionFeed-module__DQ6EBW__root",
  "soldHeader": "CollectionFeed-module__DQ6EBW__soldHeader",
  "table": "CollectionFeed-module__DQ6EBW__table",
  "withAttributes": "CollectionFeed-module__DQ6EBW__withAttributes",
});
